var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 165,
    viewBox: "0 0 165 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 0C37.125 0 0 37.125 0 82.5C0 127.875 37.125 165 82.5 165C127.875 165 165 127.875 165 82.5C165 37.125 127.875 0 82.5 0Z",
    fill: "#29B6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.75 45.375L108.487 124.162C108.487 124.162 107.663 127.875 103.538 127.875C101.063 127.875 99.825 126.638 99.825 126.638L66 99L49.5 90.75L28.4625 84.975C28.4625 84.975 24.75 83.7375 24.75 80.85C24.75 78.375 28.4625 77.1375 28.4625 77.1375L116.325 42.075C116.325 42.075 119.212 41.25 120.862 41.25C122.1 41.25 123.338 41.6625 123.338 43.3125C123.75 44.55 123.75 45.375 123.75 45.375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3751 109.313L64.3501 123.338C64.3501 123.338 63.9376 123.75 63.1126 123.75C62.7001 123.75 62.7001 123.75 62.2876 123.75L66.4126 99L78.3751 109.313Z",
    fill: "#B0BEC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.837 58.575C106.012 57.75 104.775 57.3375 103.95 58.1625L49.5 90.75C49.5 90.75 58.1625 115.088 59.4 119.213C60.6375 123.338 61.875 123.338 61.875 123.338L66 98.5875L106.425 61.05C107.25 60.6375 107.662 59.4 106.837 58.575Z",
    fill: "#CFD8DC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.8c2cf4ad4e772e85d60345ded51fb71f.svg";
export { ForwardRef as ReactComponent };